import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi } from "@/lib/admin-api";
import type { Product } from "@/types";

/**
 * Fetch the role-assignable products (GET /admin/products) once on mount. Shared by role-manager and
 * invite-user-form so the two dropdowns are populated identically and can't drift. Graceful degradation:
 * on error the list stays empty and a single toast surfaces the failure.
 */
export function useProducts(): { products: Product[]; isLoading: boolean } {
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    adminApi.products
      .list()
      .then((p) => {
        if (!cancelled) setProducts(p);
      })
      .catch((err) => {
        if (!cancelled)
          toast.error(err instanceof Error ? err.message : "Failed to load products.");
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { products, isLoading };
}
